module.exports = __webpack_public_path__ + "img/xhs.55bfa95a.jpg";